import React, { Component } from 'react';
import Slider from 'infinite-react-carousel';

class Testimonials extends Component {
   render() {
      const settings = {
         arrows: false,
         dots: true,
         autoplay: true,
      };

      return (
         <section id="testimonials">
            <div className="text-container">
               <div className="row">
                  <div className="two columns header-col">
                     <h1><span>Testimonial <br></br> What my students say</span></h1>
                  </div>
                  <div className="ten columns flex-container text-center">
                     {this.props.data &&
                        <Slider {...settings}>
                           {this.props.data.testimonials.map((testimonials) => (
                              <span key={testimonials.user}>
                                 <div className="three columns">
                                    <img className="profile-pic" src={testimonials.avatar} alt="User" />
                                 </div>
                                 <blockquote>
                                    <p>{testimonials.text}</p>
                                    <cite>{testimonials.user}</cite>
                                 </blockquote>
                              </span>
                           ))}
                        </Slider>
                     }
                  </div>
               </div>
            </div>
         </section>
      );
   }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/Components/Testimonials.js